/* eslint-disable */
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getIngresosArticulo } from "../../services/IngresoArticuloService";
import { getCacheData } from "../../services/CacheService";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
  codigo: "",
  idArea: "",
  idProveedor: "",
  usuario: "",
  fechaCreacionDesde: null,
  fechaCreacionHasta: null,
  estadoActual: "todo",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "activo",
    descripcion: "Activo",
  },
  {
    id: "anulado",
    descripcion: "Anulado",
  },
];

const nameItemsText = "Ingreso de Artículos (No Cristales)";
//
// #############################################################################
//
const IngresoArticuloTable = () => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [ingresos, setIngresos] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [usuarios, setUsuarios] = useState([]);
  const [areas, setAreas] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [valueACArea, setValueACArea] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACArea, setInputValueACArea] = useState("");
  const [valueACProveedor, setValueACProveedor] = useState({
    id: "",
    label: "",
  });
  const [inputValueACProveedor, setInputValueACProveedor] = useState("");

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_area",
      headerName: "Area de ingreso",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_area;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_proveedor",
      headerName: "Proveedor",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_proveedor + (params.row.contacto_proveedor ? " - " + params.row.contacto_proveedor : "");
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_creacion",
      headerName: "Fecha de creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_creacion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "estado",
      headerName: "Estado actual",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = "ERR";
        switch (params.row.estado) {
          case "activo":
            _val = "ACTIVO";
            break;
          case "anulado":
            _val = "ANULADO";
            break;
          default:
            _val = "ERROR";
        }
        return _val;
      },
    },
    {
      field: "usuario",
      headerName: "Operador",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="ver">
            <IconButton
              size="small"
              aria-label="view"
              onClick={() => obtieneIngreso(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>

          {params.row.editar === true && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => editaIngreso(params.row, "update")}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.anular === true && (
            <Tooltip title="anular">
              <IconButton
                size="small"
                aria-label="delete"
                onClick={() => { editaIngreso(params.row, "delete") }}
              >
                <RemoveCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadProveedores();
    loadAreas();
    loadUsuarios();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ##########################################################################
  //
  const loadUsuarios = async () => {
    const response = await getCacheData("usuario")
    if (response.ok) {
      setUsuarios(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.interno_externo === "interno" && area.actividad === "produccion" && area.produccion_ingresa_articulos);
      let _areas = [];
      _areas = _response.map((item) => {
        return {
          id: item.id,
          descripcion: item.descripcion,
        };
      });
      setAreas(_areas);
    } else {
      setAreas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion + (item.contacto ? " - " + item.contacto : "")
        });
      });
      setProveedores(_var);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {

    let _params = {
      codigo: searchData.codigo,
      idArea: searchData.idArea,
      idProveedor: searchData.idProveedor,
      usuario: searchData.usuario,
      fechaCreacionDesde: searchData.fechaCreacionDesde,
      fechaCreacionHasta: searchData.fechaCreacionHasta,
      estadoActual: searchData.estadoActual,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getIngresosArticulo(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setIngresos(response.data.data);
    } else {
      setIngresos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setCurrentPage(0);
    setTotalRowsCount(0);
    setSearchData(initialSearchData);
    setValueACArea({ id: "", descripcion: "" });
    setValueACProveedor({ id: "", descripcion: "" });
    setIngresos([]);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ###############################################################################
  //
  const obtieneIngreso = (parRow, parAction) => {
    navigate("/ingreso-articulo/" + parRow.id + "/" + parAction);
  };
  //
  // ################################################################################
  //
  const nuevoIngreso = () => {
    navigate("/ingreso-articulo/new", { state: { action: "new" } });
  };
  //
  // ################################################################################
  //
  const editaIngreso = (parRow, parAction) => {
    navigate("/ingreso-articulo/" + parRow.id + "/" + parAction);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo"
                  label="Código de Ingreso"
                  variant="outlined"
                  size="small"
                  name="codigo"
                  value={searchData.codigo ? searchData.codigo : ""}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-area"
                  size="small"
                  value={
                    valueACArea && valueACArea.id ? valueACArea : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArea(newValue);
                    setSearchData({
                      ...searchData,
                      idArea: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArea}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArea(newInputValue);
                  }}
                  options={areas}
                  getOptionLabel={(option) => option.descripcion || ""}
                  renderInput={(params) => <TextField {...params} label="Area de Ingreso " />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-proveedor"
                  size="small"
                  value={
                    valueACProveedor && valueACProveedor.id
                      ? valueACProveedor
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACProveedor(newValue);
                    setSearchData({
                      ...searchData,
                      idProveedor: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACProveedor}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACProveedor(newInputValue);
                  }}
                  options={proveedores}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Proveedor" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel
                    id="usuario-select-label"
                    sx={{
                      transform: "translate(15px, 10px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -8px) scale(0.75)",
                      },
                    }}
                  >
                    Usuario de registración
                  </InputLabel>
                  <Select
                    labelId="usuario-select-label"
                    id="usuario-registracion-select"
                    name="usuario"
                    value={searchData.usuario}
                    label="Usuario de registración"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {usuarios.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.nombre}, {item.apellido}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionDesde"
                  label="Creación Desde Fecha"
                  variant="outlined"
                  size="small"
                  name="fechaCreacionDesde"
                  value={searchData.fechaCreacionDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaCreacionDesde) =>
                    handleChangeFechaCreacionDesde(fechaCreacionDesde)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionHasta"
                  label="Creación hasta fecha"
                  variant="outlined"
                  name="fechaCreacionHasta"
                  value={searchData.fechaCreacionHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaCreacionHasta) =>
                    handleChangeFechaCreacionHasta(fechaCreacionHasta)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="estado-actual-select-label">Estado actual</InputLabel>
                  <Select
                    labelId="estado-actual-select-label"
                    id="estado-actual-select"
                    name="estadoActual"
                    value={searchData.estadoActual}
                    label="Estado actual"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="crear nuevo ingreso de artículos">
                    <Button
                      fullWidth
                      className="btn-add"
                      variant="contained"
                      size="small"
                      onClick={nuevoIngreso}
                      startIcon={<Add />}
                    >
                      Nuevo
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={ingresos}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default IngresoArticuloTable;